<template>
    <header :style="headerBackgroundColor">
        <img class="logo d-none d-md-block" :src="logo" :alt="logoTitle" v-if="logo">
        <h2
            class="title"
            :style="headerTitleColor">
            {{title}}
        </h2>
    </header>
</template>

<script>
export default {
    name: "custom-form-create-header-component",
    props: {
        logo: {
            type: String,
            required: false,
            default: null
        },
        logoTitle: {
            type: String,
            required: false,
            default: null
        },
        title:{
            type: String,
            required: true,
        },
        bgColor: {
            type: String,
            required: false,
            default: '#06a1ff'
        },
        titleColor: {
            type: String,
            required: false,
            default: '#fff'
        }
    },
    computed: {
        headerBackgroundColor() {
            return {
                'background-color': this.bgColor,
            }
        },
        headerTitleColor() {
            return {
                'color': this.titleColor
            }
        }
    }
}
</script>

<style scoped lang="scss">
    header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        column-gap: $grid-gutter-width;
        padding: map-get($grid-gutter-spacing, 'twenty-one');

        .logo {
            width: 200px;
        }

        .title {
            margin-bottom: 0;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'md')){
        header {
            flex-direction: row;
        }
    }
</style>
